import { rootPath } from '@js/utils/url';
import { deleteWishlistItem } from '../render';

const templates = [
  {
    id: "wishlist-link",
    data: "wishlist",
    template: `
      <a href="{{ wishlist.url }}" class="wk-link wk-link--{{ wishlist.state }}" title="{{ locale.view_wishlist }}">
        <div class="wk-icon wk-link__icon">{% include "wishlist-icon" %}</div>
        <span class="wk-link__label">{{ locale.wishlist }}</span>
        <span class="wk-link__count">{{ wishlist.item_count }}</span>
      </a>
    `,
  },
  {
    id: "wishlist-button",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        const select = document.querySelector("form select[name='id']");
        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          select ? select.value : undefined,
        );
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product"),
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        deleteWishlistItem(event);
      }
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}

      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-icon" %}

      {% if itemId %}
        {% assign scope = "item" %}
        {% assign targetId = itemId %}
        {% assign icon_name = "remove-icon" %}
      {% endif %}

      <button type="button" class="wk-button wk-button--{{ btn_action }} {{ addClass }} wish-button" title="{{ btn_title }}" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <div class="wk-icon wish-button__icon">{% include icon_name %}</div>
      </button>
    `,
  },
  {
    id: "wishlist-button-floating",
    data: "product",
    template: `
      {% include "wishlist-button" addClass: "wk-button--floating" %}
    `,
  },
  {
    id: "wishlist-page",
    data: "wishlist",
    events: {
      "click a[data-wk-share]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.requestWishlistSharing({
          wkShareService: event.currentTarget.getAttribute(
            "data-wk-share-service",
          ),
          wkShare: event.currentTarget.getAttribute("data-wk-share"),
          wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
        });
      },
    },
    template: `
      <div class='wrapper wk-page {% if wishlist.read_only %}wk-page--shared{% endif %}'>
      {% if wishlist.item_count == 0 %}

        <div class="tw-font-medium tw-text-xl tw-flex tw-justify-center tw-my-8">
          {{ locale.wishlist_empty_note }}
        </div>

      {% else %}

        {% if customer_accounts_enabled and customer == null and wishlist.read_only == false %}
          <div class="tw-mb-4">
            <div class="note tw-flex tw-items-center tw-rounded tw-px-4 tw-py-2 tw-bg-blue-200">
              <div class="tw-text-blue-500 tw-text-sm">
                <p class="tw-mb-0">{{ locale.login_or_signup_note }}</p>
              </div>
            </div>
          </div>
        {% endif %}

        <div id="wishlist-results">

          <div class="wkItemsBtnGroup tw-bg-light-100 tw-hidden">
            <button class="deleteWkItems wk-icon tw-text-gray-400 hover:tw-text-red-500">
              {% include "trash-icon" %} Delete
              <span class="itemsCount"></span>
            </button>

            <button class="cancelDelete tw-text-gray-400 hover:tw-text-red-500" type="button">
              {% include "remove-icon" %} Cancel
            </button>
          </div>

          <div class="ais-Hits-list collection__products-list">
          {% assign item_count = 0 %}
          {% assign products = wishlist.products | reverse %}
          {% for product in products %}
            {% assign item_count = item_count | plus: 1 %}
            {% unless limit and item_count > limit %}
              <div
                class="product__item hover:tw-shadow-lg"
                data-render="product"
                data-shopify-id="{{ product.id }}"
                data-wk-item="{{ product.wishlist_item_id }}"
              >
                {% unless wishlist.read_only %}
                  {% include "wishlist-button-floating" itemId: product.wishlist_item_id %}
                {% else %}
                  {% include "wishlist-button-floating" product: product %}
                {% endunless %}

                <a
                  id="product-{{ product.id }}"
                  class="product-link"
                  href="${rootPath().replace(/\/$/, '')}{{ product.url }}"
                  aria-label="{{ product.title | replace: '"', '&quot;' }}"
                >
                  <div class="tw-flex tw-flex-col tw-items-center tw-h-full tw-justify-between">
                    <img
                      class="tw-h-60 tw-object-contain"
                      loading="lazy"
                      src="{{ product.featured_image | img_url | '480x480' }}"
                      srcset="{{ product.featured_image | img_url: '600x600' }} 1.5x,
                              {{ product.featured_image | img_url: '1024x1024' }} 2.5x,
                              {{ product.featured_image | img_url: '1024x1024' }} 3x"
                      alt="{{ product.title | escape }}"
                    />

                    <div class="product-information sm:tw-p-0 sm:tw-pt-0 tw-w-full tw-flex tw-flex-col">
                      <h3 class="title tw-mx-0 tw-my-4 tw-text-base tw-font-normal tw-text-black">{{ product.title }}</h3>

                      <div class="product__labels-wrapper tw-w-full" data-component="ProductVariants">
                        <div class="product-label product-label--placeholder"></div>
                      </div>
                    </div>
                  </div>
                </a>

              </div>
            {% endunless %}
          {% endfor %}
          </div>
        </div>

        {% comment %}
        {% unless wishlist.read_only %}
          {% include "wishlist-button-clear" %}
        {% endunless %}
        {% endcomment %}

        {% unless wishlist.read_only %}
          <div class="tw-my-12">
            <div class="section__header">
              <div class="section__title-divider"></div>
              <h6 class="section__title">
                {{ locale.share_wishlist }}
              </h6>
            </div>

            <ul class="wk-sharing__list">
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-fb" %}</li>
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-twitter" %}</li>
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-email" %}</li>
              <li class="wk-sharing__list-item">{% include "wishlist-share-button-link" %}</li>
              {% comment %}<li class="wk-sharing__list-item">{% include "wishlist-share-button-contact" %}</li>{% endcomment %}
            </ul>
            <div class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
          </div>
        {% endunless %}
      {% endif %}
      </div>
    `,
  },
  {
    id: "wishlist-page-shared",
    data: "shared_wishlist",
    template: `
      {% assign wishlist = shared_wishlist %}
      {% include "wishlist-page" with wishlist %}
    `,
  },
  {
    id: "wishlist-button-bulk-add-to-cart",
    data: "wishlist",
    events: {
      "click button[data-wk-bulk-add-to-cart]": (event) => {
        WishlistKing.toolkit.requestAddAllToCart(
          event.currentTarget.getAttribute("data-wk-bulk-add-to-cart"),
        );
      },
    },
    template: `
      {% assign btn_text = locale.add_all_to_cart %}
      {% assign btn_title = locale.add_all_to_cart %}

      <button type="button" class="wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-clear",
    data: "wishlist",
    events: {
      "click button[data-wk-clear-wishlist]": (event) => {
        WishlistKing.toolkit.clear(
          event.currentTarget.getAttribute("data-wk-clear-wishlist"),
        );
      },
    },
    template: `
      {% assign btn_text = locale.clear_wishlist %}
      {% assign btn_title = locale.clear_wishlist %}

      <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-icon",
    template: `
      <svg width="24px" height="24px" viewBox="0 0 25 22" fill="none" class="wk-icon__svg">
        <path stroke="url(#SlrsSvgGradient) #f12711" stroke-width="3" d="M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z" />
      </svg>
    `,
  },
  {
    id: "trash-icon",
    template: `
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
        <path d="M1.45459 3.63634H2.90914H14.5455" stroke="currentColor" stroke-width="1.45455" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M13.8183 3.63639C13.8183 3.23472 13.4927 2.90911 13.091 2.90911C12.6893 2.90911 12.3637 3.23472 12.3637 3.63639H13.8183ZM3.63645 3.63639C3.63645 3.23472 3.31084 2.90911 2.90918 2.90911C2.50752 2.90911 2.18191 3.23472 2.18191 3.63639H3.63645ZM4.36373 3.63639C4.36373 4.03805 4.68934 4.36366 5.091 4.36366C5.49266 4.36366 5.81827 4.03805 5.81827 3.63639H4.36373ZM10.1819 3.63639C10.1819 4.03805 10.5075 4.36366 10.9092 4.36366C11.3108 4.36366 11.6365 4.03805 11.6365 3.63639H10.1819ZM12.3637 3.63639V13.8182H13.8183V3.63639H12.3637ZM12.3637 13.8182C12.3637 14.2199 12.0381 14.5455 11.6365 14.5455V16C12.8414 16 13.8183 15.0232 13.8183 13.8182H12.3637ZM11.6365 14.5455H4.36373V16H11.6365V14.5455ZM4.36373 14.5455C3.96206 14.5455 3.63645 14.2199 3.63645 13.8182H2.18191C2.18191 15.0232 3.15874 16 4.36373 16V14.5455ZM3.63645 13.8182V3.63639H2.18191V13.8182H3.63645ZM5.81827 3.63639V2.18184H4.36373V3.63639H5.81827ZM5.81827 2.18184C5.81827 1.78018 6.14388 1.45457 6.54554 1.45457V2.21729e-05C5.34056 2.21729e-05 4.36373 0.976856 4.36373 2.18184H5.81827ZM6.54554 1.45457H9.45463V2.21729e-05H6.54554V1.45457ZM9.45463 1.45457C9.8563 1.45457 10.1819 1.78018 10.1819 2.18184H11.6365C11.6365 0.976856 10.6596 2.21729e-05 9.45463 2.21729e-05V1.45457ZM10.1819 2.18184V3.63639H11.6365V2.18184H10.1819Z" fill="currentColor"/>
      </svg>
    `
  },
  {
    id: "remove-icon",
    template: `
      <svg class="wk-icon__svg wk-remove-icon" width="12px" height="12px" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path stroke-width="1.5" vector-effect="non-scaling-stroke" d="M0.309,0.309a0.9,0.9,0,0,1,1.268,0L63.691,62.423a0.9,0.9,0,0,1-1.268,1.268L0.309,1.577A0.9,0.9,0,0,1,.309.309Z"/>
        <path stroke-width="1.5" vector-effect="non-scaling-stroke" d="M63.691,0.309a0.9,0.9,0,0,1,0,1.268L1.577,63.691A0.9,0.9,0,0,1,.309,62.423L62.423,0.309A0.9,0.9,0,0,1,63.691.309Z"/>
      </svg>
    `,
  },
  {
    id: "wishlist-share-button-fb",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.7182 0.0028866L8.91915 0C6.89796 0 5.59177 1.3401 5.59177 3.41427V4.98847H3.78289C3.62658 4.98847 3.5 5.1152 3.5 5.27151V7.55235C3.5 7.70866 3.62672 7.83524 3.78289 7.83524H5.59177V13.5905C5.59177 13.7468 5.71835 13.8734 5.87466 13.8734H8.23474C8.39105 13.8734 8.51763 13.7467 8.51763 13.5905V7.83524H10.6326C10.7889 7.83524 10.9155 7.70866 10.9155 7.55235L10.9164 5.27151C10.9164 5.19645 10.8865 5.12458 10.8335 5.07146C10.7806 5.01835 10.7084 4.98847 10.6334 4.98847H8.51763V3.654C8.51763 3.0126 8.67047 2.68699 9.506 2.68699L10.7179 2.68656C10.8741 2.68656 11.0007 2.55983 11.0007 2.40367V0.285773C11.0007 0.129753 10.8742 0.00317526 10.7182 0.0028866Z" fill="#3B5898"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-twitter",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2.51329C13.4794 2.74167 12.9246 2.89304 12.3462 2.96654C12.9412 2.61129 13.3954 2.05304 13.6089 1.38017C13.0541 1.71092 12.4416 1.94454 11.7889 2.07492C11.2621 1.51404 10.5114 1.16667 9.69238 1.16667C8.10338 1.16667 6.82412 2.45642 6.82412 4.03754C6.82412 4.26504 6.84338 4.48379 6.89062 4.69204C4.5045 4.57567 2.39313 3.43204 0.97475 1.68992C0.727125 2.11954 0.581875 2.61129 0.581875 3.14067C0.581875 4.13467 1.09375 5.01579 1.85675 5.52592C1.39562 5.51717 0.94325 5.38329 0.56 5.17242C0.56 5.18117 0.56 5.19254 0.56 5.20392C0.56 6.59867 1.55487 7.75717 2.8595 8.02404C2.62587 8.08792 2.37125 8.11854 2.107 8.11854C1.92325 8.11854 1.73775 8.10804 1.56362 8.06954C1.9355 9.20617 2.99075 10.0418 4.2455 10.0689C3.269 10.8328 2.02912 11.293 0.686875 11.293C0.4515 11.293 0.22575 11.2825 0 11.2537C1.27137 12.0735 2.77812 12.5417 4.403 12.5417C9.6845 12.5417 12.572 8.16667 12.572 4.37442C12.572 4.24754 12.5676 4.12504 12.5615 4.00342C13.1311 3.59917 13.6097 3.09429 14 2.51329Z" fill="#1DA1F2"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-email",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.90908 1.90909H12.0909C12.7909 1.90909 13.3636 2.48182 13.3636 3.18182V10.8182C13.3636 11.5182 12.7909 12.0909 12.0909 12.0909H1.90908C1.20908 12.0909 0.636353 11.5182 0.636353 10.8182V3.18182C0.636353 2.48182 1.20908 1.90909 1.90908 1.90909Z" stroke="#F12711" stroke-width="1.27273" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.3636 3.18182L6.99999 7.63636L0.636353 3.18182" stroke="#F12711" stroke-width="1.27273" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-link",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z" fill="#323232"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-contact",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-button" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
        <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      </a>
    `,
  },
];

export default templates;
